import type { CookieAttributes } from 'js-cookie'
import Cookie from 'js-cookie'
import dayjs from './date'

const mockTokenName = 'STMockAccessToken'
const tokenName = 'AccessToken'
const domains = ['.qingshuxuetang.com']
const localDomain = 'localhost'

const getCookie = (name: string) => Cookie.get(name)
const setCookie = (
  name: string,
  value: string,
  option?: CookieAttributes,
): void => {
  Cookie.set(name, value, { ...(option || {}) })
  domains.forEach(domain => Cookie.set(name, value, { domain, ...(option || {}) }))
  if (location.host?.includes(localDomain)) {
    Cookie.set(name, value, { domain: location.host, ...(option || {}) })
  }
  Cookie.set(name, value, {
    domain: location.host.replace(/[^.]+/, ''),
    ...(option || {}),
  })
}
const removeCookie = (name: string) => {
  Cookie.remove(name)
  domains.forEach(domain => Cookie.remove(name, { domain }))
  Cookie.remove(name, { domain: location.host })
  Cookie.remove(name, { domain: location.host.replace(/[^.]+/, '') })
}
const getUsedTokenName = () => window.location.host.includes('mock') ? mockTokenName : tokenName
const getToken = () => getCookie(getUsedTokenName())
const setToken = (value: string) => setCookie(getUsedTokenName(), value, { expires: dayjs().add(1, 'M').toDate() })
const removeToken = () => removeCookie(getUsedTokenName())

const setDomain = (newDomain: string, ...newDomains: string[]) => {
  domains.length = 0
  domains.push(newDomain, ...newDomains)
}
export { setDomain, getCookie, setCookie, removeCookie, getToken, setToken, removeToken }
